<div>
  <table class="room-allocation-table">
    <!-- header -->
    <thead>
      <tr>
        <th class="rat-header-action"></th>

        <!-- additional columns -->
        <th scope="col"
          [class]="'text-truncate dynamic-col-th ' + resourceType.toLocaleLowerCase() + '-display-from-' + row.showFromScreenSize + ' rat-header-' + row.columnName"
          *ngFor="let row of model.additionalColums;let i=index" attr.colspan="{{row.columnSpan}}">
          {{row.captionLocaleKey|translate}}
        </th>

        <!-- COLUMN: INFO & CALENDAR BUTTONS -->
        <th scope="col" class="dynamic-col-td rat-header-meta"></th>
        <th scope="col" *ngIf="model.additionalColums.length === 0" class="dynamic-col-td">&nbsp;</th>

        <th scope="col" class="rat-header-timestream pr-2">
          <!-- timeline -->
          <table class="room-allocation-time-stream" border="0">
            <tr>
              <ng-container *ngFor="let i of timeStream">
                <th colspan="2">{{getTimeString(i)}}</th>
                <th *ngIf="needSpace(i)">&nbsp;</th>
              </ng-container>
            </tr>
            <tr>
              <ng-container *ngFor="let cs of colspans">
                <td *ngIf="cs === 1">
                  &nbsp;
                </td>
                <td *ngIf="cs === 3" colspan="3">
                  <div></div>
                  <div></div>
                </td>
              </ng-container>
            </tr>
          </table>

        </th>
      </tr>
    </thead>

    <tbody style="white-space:nowrap;">
      <!-- colons -->
      <tr *ngFor="let item of model.displayItems; let i = index" [class]="zebra(i)">

        <td class="room-allocation-table-nowrap action-column">
          <app-tooltip-button *ngIf="hasAnyFreeSlot(item.scheduleItems) !== true" btnClass="text-warning py-1"
            [text]="'RESERVATION_TIME_FRAME_OCCUPIED'|translate" icon="warning" size="large" placement="right">
          </app-tooltip-button>

          <ng-container [ngSwitch]="toFlagSet([item.isRessourceAvailable, item.isBookingAllowed])"
            *ngIf="hasAnyFreeSlot(item.scheduleItems)">
            <Button *ngSwitchCase="'11'" (click)="onCreateReservationByButton(item)"
              class="btn btn-info btn-sm w-100">{{item.actionLabel|translate}}</Button>

            <!-- warning icon data colum cells options -->
            <app-tooltip-button *ngSwitchCase="'10'" btnClass="text-warning py-1" [text]="item.warning" icon="warning"
              size="large" placement="right">
            </app-tooltip-button>

            <app-tooltip-button *ngSwitchDefault btnClass="text-danger py-1" [text]="item.warning" icon="x" size="large"
              placement="right">
            </app-tooltip-button>
          </ng-container>

        </td>

        <!-- additional columns -->
        <td *ngFor="let row of item.additionalColumsData"
          [class]="'text-truncate dynamic-col-td ' + resourceType.toLocaleLowerCase() + '-display-from-' + row.showFromScreenSize">
          {{row.fieldValue}}</td>


        <!-- info button and calender -->
        <td>
          <!-- room-info -->
          <app-button (click)="onOpenRoomInfo(item, $event)" btnStyle="info" size="small" icon="info"
            [text]="openResourceInfoText" hideText="true" class="info-button px-1"
            guestClass="room-allocation-info-button">
          </app-button>
          <!-- calendar -->
          <app-button (click)="onOpenSchedule(item)" btnStyle="info" size="small" icon="calendar"
            [text]="openResourceCalendarText" hideText="true" guestClass="room-allocation-calendar-button"></app-button>
        </td>
        <!-- todo: extract this block -->
        <td class="room-allocation-table-nowrap">
          <div #progressBar style="position: relative; cursor: pointer;" class="progress"
            [title]="'TIMESPAN_FREE'|translate" (click)="onClickTimeline($event, item)">
            <ng-container *ngFor="let block of getTimeLine(item.scheduleItems)">
              <ng-container *ngFor="let e of block.events">
                <div [style.left]="showTimeStreamLeft(e)" [style.width]="showTimeStreamWidth(e)"
                  class="progress-occupancy" [title]="getTimeSpanString(e)"
                  (click)="notifyOccupiedTimespan(e); $event.stopPropagation()"></div>
              </ng-container>
            </ng-container>
          </div>

        </td>
      </tr>

    </tbody>

  </table>
</div>